/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserGroupListRequest {
    getFixupPrototypeFunction() { return UserGroupListRequest.fixupPrototype; }

    static newInstance(model: Partial<UserGroupListRequest>): UserGroupListRequest {
        let obj = Object.assign(new UserGroupListRequest(), model);
        UserGroupListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserGroupListRequest>): UserGroupListRequest {
        if (!model) return null;
        return UserGroupListRequest.newInstance(<UserGroupListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserGroupListRequest) {
        if (!obj) return;

        models.UserGroupListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserGroupListRequest): boolean {
        Object.setPrototypeOf(obj, UserGroupListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.UserGroupFilters.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.UserGroupSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.UserGroupSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.UserGroupFilters;

}
